import { Check, Minus, X } from "@phosphor-icons/react";
import type { ReactNode } from "react";
import { match } from "ts-pattern";

import type { BillingConfigCriteria } from "../../types";

interface CriteriaDisplayProps {
  criteria: BillingConfigCriteria;
}

export function CriteriaDisplay({ criteria }: CriteriaDisplayProps): ReactNode {
  if (!criteria.length) {
    return null;
  }

  return (
    <div className="text-r8-sm space-y-1">
      {criteria.map((criterion, idx) => (
        <div key={idx} className="flex gap-1 items-start">
          {match(criterion)
            .with({ type: "equals", subtype: "boolean" }, (criterion) => (
              <>
                {criterion.value ? (
                  <Check size={20} className="fill-r8-gray-8 shrink-0" />
                ) : (
                  <X size={20} className="fill-r8-gray-8 shrink-0" />
                )}
                <span>{criterion.title}</span>
              </>
            ))
            .otherwise((criterion) => (
              <div key={idx} className="flex gap-1 items-start">
                <Minus size={20} className="fill-r8-gray-8 shrink-0" />
                <div>
                  {criterion.title} is {criterion.description}
                </div>
              </div>
            ))}
        </div>
      ))}
    </div>
  );
}
